var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCmdStart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 17.7165V1.5329C4.00023 1.4308 4.03317 1.3309 4.09494 1.24504C4.1567 1.15918 4.24468 1.09095 4.34847 1.04845C4.45225 1.00596 4.56748 0.990965 4.6805 1.00526C4.79352 1.01955 4.89958 1.06253 4.98613 1.1291L16.3376 9.0868C16.4022 9.1364 16.4541 9.1978 16.49 9.26687C16.5258 9.33594 16.5447 9.41108 16.5454 9.48722C16.5461 9.56337 16.5285 9.63876 16.4938 9.70832C16.4592 9.77788 16.4083 9.84 16.3446 9.89049L4.99314 18.1148C4.90718 18.183 4.80101 18.2276 4.68741 18.2432C4.57381 18.2588 4.45759 18.2447 4.35271 18.2026C4.24784 18.1606 4.15877 18.0923 4.0962 18.0061C4.03364 17.9198 4.00023 17.8193 4 17.7165ZM5.19212 2.6957V16.5247L15.0411 9.49453L5.19212 2.6957Z",
    fill: "#455079",
    stroke: "#455079"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCmdStart);
export default __webpack_public_path__ + "static/media/cmd-start.13f21bd092a95b24b20e43420a13ed36.svg";
export { ForwardRef as ReactComponent };